module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "fmh"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/TNTC_Romans3#ch4"
    }
  }, [_vm._v("SELECT BIBLIOGRAPHY")])]), _vm._v(" "), _c('h2', {
    staticClass: "ahd1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Commentaries on Romans")])]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Achtemeier, Paul J. (1985), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Romans")]), _vm._v(", Interpretation (Atlanta: John Knox).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Barrett, Charles Kingsley (1971), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("A Commentary on the Epistle to the Romans")]), _vm._v(", rev. edn, BNTC (London: Continuum).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Barth, Karl (1933), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Epistle to the Romans")]), _vm._v(" (London: Oxford University Press).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Bence, Clarence L. (1996), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Romans: A Commentary for Bible Students")]), _vm._v(", Wesleyan Bible Study Commentary (Indianapolis: Wesleyan Publishing House).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Best, Ernest (1967), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Letter of Paul to the Romans")]), _vm._v(", CBC (Cambridge: Cambridge University Press).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Bird, Michael F. (2016), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Romans")]), _vm._v(", SGBC (Grand Rapids: Zondervan).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Black, Matthew (1973), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Romans")]), _vm._v(", NCBC (Grand Rapids: Eerdmans).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Bruce, F. F. (1963), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Epistle of Paul to the Romans")]), _vm._v(", rev. edn, TNTC (Grand Rapids: Eerdmans).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Brunner, Emil (1959), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Letter to the Romans")]), _vm._v(" (Philadelphia: Fortress).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Byrne, Brendan (1996), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Romans")]), _vm._v(", SP (Collegeville: Liturgical Press).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Cottrell, Jack (2005), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Romans")]), _vm._v(", College Press NIV Commentary (Joplin: College Press).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Cranfield, C. E. B. (1975, 1979), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("A Critical and Exegetical Commentary on the Epistle to the Romans")]), _vm._v(", ICC, 2 vols. (Edinburgh: T&T Clark).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Dodd, C. H. (1932), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Epistle of Paul to the Romans")]), _vm._v(", MNTC (New York: Harper).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Dunn, James D. G. (1988), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Romans")]), _vm._v(", WBC, 2 vols. (Dallas: Word).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Edwards, James R. (1992), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Romans")]), _vm._v(", UBCS (Grand Rapids: Baker).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Fitzmyer, Joseph A. (1993), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Romans")]), _vm._v(", AB (New York: Doubleday).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Gignac, Alain (2014), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("L’Épître aux Romains")]), _vm._v("."), _c('span', {
    staticClass: "bold"
  }), _vm._v("Commentaire biblique (Paris: Cerf ).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Godet, Frederick (1895), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Commentary on St. Paul’s Epistle to the Romans ")]), _vm._v("(Edinburgh: T&T Clark).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Haacker, Klaus (1999), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Der Brief des Paulus an die Römer")]), _vm._v(", THKNT (Leipzig: Evangelische Verlaganstalt).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Harrison, Everett F. and Donald A. Hagner (2008), ‘Romans’, in T. Longman and D. E. Garland (eds.), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Expositor’s Bible Commentary")]), _vm._v(" (Grand Rapids: Zondervan), pp. 21–237.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Harrisville, Roy A. (1980), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Romans")]), _vm._v(", ACNT (Minneapolis: Augsburg).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Heil, John Paul (1987), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Paul’s Letter to the Romans: A Reader-Response Commentary ")]), _vm._v("(Eugene: Wipf and Stock).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Hultgren, Arland J. (2011), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Paul’s Letter to the Romans")]), _vm._v(" (Grand Rapids: Eerdmans).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Jackson W. [pseudonym] (2019), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Reading Romans with Eastern Eyes: Honor and Shame in Paul’s Message and Mission")]), _vm._v(" (Downers Grove: IVP Academic).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Jewett, Robert (2007), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Romans: A Commentary")]), _vm._v(", Hermeneia (Minneapolis: Fortress).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Johnson, Luke Timothy (2001), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Reading Romans: A Literary and Theological Commentary")]), _vm._v(" (Macon: Smyth & Helwys).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Käsemann, Ernst (1980), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Commentary on Romans")]), _vm._v(" (Grand Rapids: Eerdmans).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Keck, Leander E. (2005), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Romans")]), _vm._v(", ANTC (Nashville: Abingdon).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Keener, Craig S. (2009), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Romans")]), _vm._v(", NCCS (Eugene: Cascade).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Kruse, Colin G. (2012), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Paul’s Letter to the Romans")]), _vm._v(", PNTC (Grand Rapids: Eerdmans).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Leenhardt, Franz J. (1961), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Epistle to the Romans ")]), _vm._v("(London: Lutterworth).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Lohse, Eduard (2003), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Der Brief an die Römer")]), _vm._v(", KEK (Göttingen: Vandenhoeck & Ruprecht).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Longenecker, Richard N. (2016), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Epistle to the Romans")]), _vm._v(", NIGTC (Grand Rapids: Eerdmans).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Manson, T. W. (1962), ‘Romans’, in M. Black and H. H. Rowley (eds.), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Peake’s Commentary on the Bible")]), _vm._v(" (London: Nelson), pp. 940–953.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Matera, Frank J. (2010), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Romans")]), _vm._v(", Paideia (Grand Rapids: Eerdmans).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Michel, Otto (1963), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Der Brief an die Römer")]), _vm._v(", KEK, 12th edn (Göttingen: Vandenhoeck & Ruprecht).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Middendorf, Michael P. (2013, 2016), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Romans")]), _vm._v(", CC, 2 vols. (St. Louis: Concordia).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Moo, Douglas J. (2018), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Epistle to the Romans")]), _vm._v(", rev. edn, NICNT (Grand Rapids: Eerdmans).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Morris, Leon (1988), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Epistle to the Romans")]), _vm._v(", PNTC (Grand Rapids: Eerdmans).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Murray, John (1960), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Epistle to the Romans")]), _vm._v(", NICNT, 2 vols. (Grand Rapids: Eerdmans).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Nygren, Anders (1949), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Commentary on Romans")]), _vm._v(" (Philadelphia: Fortress).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Osborne, Grant (2004), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Romans")]), _vm._v(", IVPNTC (Downers Grove: InterVarsity Press).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Pate, C. Marvin (2013), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Romans")]), _vm._v(", TTCS (Grand Rapids: Baker).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Peterson, David G. (2017), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Commentary on Romans")]), _vm._v(", BTCP (Nashville: Holman).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Porter, Stanley E. (2015), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Letter to the Romans: A Linguistic and Literary Commentary")]), _vm._v(" (Sheffield: Sheffield Phoenix).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Sanday, William and Arthur C. Headlam (1902), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("A Critical and Exegetical Commentary on the Epistle to the Romans")]), _vm._v(", 5th edn (Edinburgh: T&T Clark).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Schlatter, Adolf (1995), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Romans: The Righteousness of God ")]), _vm._v("(Peabody: Hendrickson).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Schnabel, Eckhard J. (2015, 2016), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Der Brief des Paulus an die Römer")]), _vm._v(", 2 vols., HTA (Witten: SCM R. Brockhaus; Giessen: Brunnen).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Schreiner, Thomas R. (2018), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Romans")]), _vm._v(", rev. edn, BECNT (Grand Rapids: Baker).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Stott, John (1994), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Romans: Good News for the World")]), _vm._v(" (Downers Grove: InterVarsity Press).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Stowers, Stanley K. (1994), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("A Rereading of Romans: Justice, Jews, and Gentiles ")]), _vm._v("(New Haven: Yale University Press).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Stuhlmacher, Peter (1994), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Paul’s Letter to the Romans: A Commentary")]), _vm._v(" (Louisville: Westminster/John Knox).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Talbert, Charles H. (2002), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Romans")]), _vm._v(", SHBC (Macon: Smyth & Helwys).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Taylor, Vincent (1955), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Epistle to the Romans")]), _vm._v(", Epworth Preacher’s Commentaries (London: Epworth).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Thielman, Frank S. (2018), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Romans")]), _vm._v(", ZECNT (Grand Rapids: Zondervan).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Thiselton, Anthony C. (2016), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Discovering Romans: Content, Interpretation, Reception")]), _vm._v(" (Grand Rapids: Eerdmans).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Toews, John E. (2004), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Romans")]), _vm._v(", BCBC (Scottdale: Herald).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Westerholm, Stephen (2004), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Understanding Paul: The Early Christian Worldview of the Letter to the Romans")]), _vm._v(" (Grand Rapids: Baker).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Wilckens, Ulrich (1978, 1980, 1982), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Der Brief an die Römer")]), _vm._v(", EKK, 3 vols. (Zurich: Benninger; Neukirchen-Vluyn: Neukirchener Theologie).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Witherington, Ben (2004), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Paul’s Letter to the Romans: A Socio-Rhetorical Commentary")]), _vm._v(" (Grand Rapids: Eerdmans).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Wolter, Michael (2014, 2020), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Der Brief an die Römer")]), _vm._v(", EKK, 2 vols. (Neukirchen-Vluyn: Neukirchener Theologie; Ostfildern: Patmos).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Wright, N. T. (2002), ‘The Letter to the Romans: Introduction, Commentary, and Reflections’, in L. E. Keck (ed.),"), _c('em', {
    staticClass: "italic"
  }, [_vm._v(" The New Interpreter’s Bible")]), _vm._v(", Vol. 10 (Nashville: Abingdon), pp. 395–770.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Ziesler, John (1989), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Paul’s Letter to the Romans")]), _vm._v(", TPINTC (London: SCM).")]), _vm._v(" "), _c('h2', {
    staticClass: "ahd1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Other commentaries, books, monographs and articles")])]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Abasciano, Brian J. (2006), ‘Corporate Election in Romans 9: A Reply to Thomas Schreiner’, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("JETS")]), _vm._v(" 49, pp. 351–371.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Achtemeier, Paul J. (1990), ‘Romans 3:1–8: Structure and Argument’, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Anglican Theological Review, Supplement Series")]), _vm._v(" 11, pp. 77–87.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Adams, Edward (1997), ‘Abraham’s Faith and Gentile Disobedience: Textual Links between Romans 1 and 4’, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("JSNT")]), _vm._v(" 65, pp. 47–66.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("—— (2000), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Constructing the World: A Study in Paul’s Cosmological Language")]), _vm._v(", SNTW (Edinburgh: T&T Clark).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Agersnap, Søren (1999), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Baptism and the New Life: A Study of Romans 6.1–14")]), _vm._v(" (Aarhus: Aarhus University Press).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Allen, Leslie C. (1964), ‘The Old Testament in Romans I – VIII’, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("VE ")]), _vm._v("3, pp. 6–41.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Anderson, R. Dean (1999), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Ancient Rhetorical Theory and Paul")]), _vm._v(", Contributions to Biblical Exegesis and Theology, rev. edn (Leuven: Peeters).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Apuleius, Lucius (1989), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Metamorphoses (The Golden Ass), Volume II: Books 7–11")]), _vm._v(", tr. J. A. Hanson, LCL (Cambridge: Harvard University Press).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Aune, David E. (1991), ‘Romans as a "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Logos Protreptikos")]), _vm._v("’, in K. P. Donfried (ed.), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Romans Debate: Revised and Expanded Edition")]), _vm._v(" (Peabody: Hendrickson), pp. 278–296.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Banks, Robert (1978), ‘Romans 7.25a: An Eschatological Thanksgiving’, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("ABR")]), _vm._v(" 26, pp. 34–42.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Barclay, John M. G. (1987), ‘Mirror-Reading a Polemical Letter: Galatians as a Test Case’, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("JSNT")]), _vm._v(" 31, pp. 73–93.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("—— (2008), ‘Is It Good News That God Is Impartial? A Response to Robert Jewett, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Romans: A Commentary")]), _vm._v("’, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("JSNT")]), _vm._v(" 31, pp. 89–111.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("—— (2015), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Paul and the Gift ")]), _vm._v("(Grand Rapids: Eerdmans).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Barrett, C. K. (1968), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The First Epistle to the Corinthians")]), _vm._v(","), _c('em', {
    staticClass: "italic"
  }), _vm._v("HNTC (New York: Harper).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("—— (1976), ‘The Allegory of Abraham, Sarah, and Hagar in the Argument of Galatians’, in J. Friedrich, W. Pöhlmann and P. Stuhlmacher (eds.), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Rechtfertigung: Festschrift für Ernst Käsemann zum 70. Geburtstag ")]), _vm._v("(Tübingen: Mohr Siebeck; Göttingen: Vandenhoeck & Ruprecht), pp. 1–16.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("—— (1977), ‘Romans 9.30 – 10.21: Fall and Responsibility of Israel’, in L. De Lorenzi"), _c('em', {
    staticClass: "italic"
  }), _vm._v("(ed.), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Die Israelfrage nach Rom 9 – 11 ")]), _vm._v("(Rome: Abtei von St Paul vor den Mauern), pp. 99–130.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Bassler, Jouette M. (1982), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Divine Impartiality: Paul and a Theological Axiom")]), _vm._v(", SBLDS 59 (Chico: Scholars Press).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("—— (1985), ‘Luke and Paul on Impartiality’, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Bib")]), _vm._v(" 66, pp. 546– 552.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Bauckham, Richard"), _c('em', {
    staticClass: "italic"
  }), _vm._v("(1998), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("God Crucified: Monotheism and Christology in the New Testament ")]), _vm._v("(Grand Rapids: Eerdmans).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("—— (2002), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Gospel Women: Studies in the Named Women in the Gospels")]), _vm._v(" (Grand Rapids: Eerdmans).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("—— (2011), ‘The Story of the Earth according to Paul: Romans 8:18–23’, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("RevExp")]), _vm._v(" 108, pp. 91–97.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Baum, Gregory (1965), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Is the New Testament Anti-Semitic? A Re-examination of the New Testament")]), _vm._v(" (New York: Paulist).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Baxter, A. G. and John A. Ziesler (1985), ‘Paul and Arboriculture: Romans 11:17–24’, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("JSNT")]), _vm._v(" 24, pp. 25–32.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Beare, Francis Wright (1962), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("St. Paul and His Letters")]), _vm._v(" (Nashville: Abingdon).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Beck, Brian E. (1994), ‘Reflections on 2 Corinthians 5:11 – 6:2’, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Epworth Review")]), _vm._v(" 21, pp. 85–92.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Beker, J. Christiaan (1980), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Paul the Apostle: The Triumph of God in Life and Thought ")]), _vm._v("(Philadelphia: Fortress).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Bekken, Per Jarle (2007), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Word Is Near You: A Study of Deuteronomy 30:12–14 in Paul’s Letter to the Romans in a Jewish Context")]), _vm._v(", BZNW 144 (Berlin: de Gruyter).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Bell, Richard H. (1994), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Provoked to Jealousy: The Origin and Purpose of the Jealousy Motif in Romans 9 – 11")]), _vm._v(", WUNT 2/63 (Tübingen: Mohr Siebeck).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Belleville, Linda (2005), ‘"), _c('span', {
    staticClass: "greek_roman"
  }, [_vm._v("Ιουνίαν")]), _vm._v(" . . . "), _c('span', {
    staticClass: "greek_roman"
  }, [_vm._v("ἐπίσημοι ἐν τοῖς ἀποστόλοις")]), _vm._v(": A Re-examination of Romans 16.7 in Light of Primary Source Materials’, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("NTS")]), _vm._v(" 51, pp. 231–249.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Bertschmann, Dorothea H. (2014), ‘The Good, the Bad and the State: Rom 13.1–7 and the Dynamics of Love’, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("NTS")]), _vm._v(" 60, pp. 232–249.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Bird, Michael F. (2013), ‘“One Who Will Arise over the Nations”: Paul’s Letter to the Romans and the Roman Empire’, in S. McKnight and J. B. Modica (eds.), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Jesus Is Lord, Caesar Is Not: Evaluating Empire in New Testament Studies")]), _vm._v(" (Downers Grove: InterVarsity Press Academic), pp. 146–165.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Bjerkelund, C. J. (1967), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Parakalō: Form, Funktion, und Sinn der parakalō-Sätze in den paulinischen Briefen")]), _vm._v(","), _c('em', {
    staticClass: "italic"
  }), _vm._v("Bibliotheca Theologica Norvegica 1 (Oslo: Universitetsforlaget).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Blackwell, Ben C. (2010),"), _c('span', {
    staticClass: "bold"
  }), _vm._v("‘Immortal Glory and the Problem of Death in Romans 3.23’, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("JSNT ")]), _vm._v("32, pp. 285–308.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Boers, Hendrikus (2001), ‘The Structure and Meaning of Romans 6:1–14’, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("CBQ")]), _vm._v(" 63, pp. 664–682.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Bornkamm, Günther (1969a), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Early Christian Experience")]), _vm._v(" (New York: Harper & Row).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("—— (1969b), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Paul ")]), _vm._v("(New York: Harper & Row).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Bradley, Keith R. (1987), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Slaves and Masters in the Roman Empire: A Study in Social Control")]), _vm._v(" (New York: Oxford University Press).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Bray, Gerald (ed.) (1998), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Romans")]), _vm._v(", Ancient Christian Commentary on Scripture, New Testament Vol. 6 (Downers Grove: InterVarsity Press).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Breytenbach, Cilliers (2005), ‘The “For Us” Phrases in Pauline Soteriology: Considering Their Background and Use’, in J. van der Watt"), _c('em', {
    staticClass: "italic"
  }), _vm._v("(ed.), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Salvation in the New Testament: Perspectives on Soteriology")]), _vm._v(" (Leiden: Brill), pp. 163–185.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Brookins,"), _c('span', {
    staticClass: "bold"
  }), _vm._v("Timothy A. (2013), ‘The (In)frequency of the Name “Erastus” in Antiquity: A Literary, Papyrological, and Epigraphical Catalog’, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("NTS ")]), _vm._v("59, pp. 496–516.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Bruce, F. F. (1991), ‘The Romans Debate – Continued’, in K. P. Donfried (ed.), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Romans Debate: Revised and Expanded Edition")]), _vm._v(" (Peabody: Hendrickson), pp. 175–194.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Bryant, K. Edwin (2016), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Paul and the Rise of the Slave: Death and Resurrection of the Oppressed in the Epistle to the Romans")]), _vm._v(", BibInt 143 (Leiden/Boston: Brill).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Burer, Michael H. and Daniel B. Wallace (2001), ‘Was Junia Really an Apostle? A Re-examination of Rom 16.7’, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("NTS")]), _vm._v(" 47, pp. 76–91.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Burke, Trevor J. (2006), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Adopted into God’s Family")]), _vm._v(", NSBT (Nottingham: Apollos; Downers Grove: InterVarsity Press).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Byrne, Brandon (2003), ‘Paul’s Adam Myth Revisited’, in D. Reid and M. Worthing (eds.),"), _c('em', {
    staticClass: "italic"
  }, [_vm._v(" Sin and Salvation ")]), _vm._v("(Hindmarsh: ATF Press), pp. 41–54.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Byrskog, Samuel (1997), ‘Epistolography, Rhetoric and Letter Prescript: Romans 1.1–7 as a Test Case’,"), _c('em', {
    staticClass: "italic"
  }, [_vm._v(" JSNT")]), _vm._v(" 65, pp. 27–46.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Cadwallader, Alan H. (2018), ‘Tertius in the Margins: A Critical Appraisal of the Secretary Hypothesis’, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("NTS ")]), _vm._v("64, pp. 378– 396.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("—— (2019), ‘Phoebe in and around Romans: The Weight of Marginal Reception’, in P. G. Bolt and J. R. Harrison (eds.), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Romans and the Legacy of St Paul: Historical, Theological, and Social Perspectives")]), _vm._v(", Occasional Series 1 (Macquarie Park, NSW: SCD Press), pp. 429–452.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Caird, George B. (1977), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Paul’s Letters from Prison ")]), _vm._v("(Oxford: Oxford University Press).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("—— (1980), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Language and Imagery of the Bible ")]), _vm._v("(Philadelphia: Westminster).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Calhoun, Robert Matthew (2011), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Paul’s Definitions of the Gospel in Romans 1")]), _vm._v(", WUNT 2/316 (Tübingen: Mohr Siebeck).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Calvin, John (1960), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Institutes of the Christian Religion")]), _vm._v(", ed. J. T. McNeill, tr. F. L. Battles, Library of Christian Classics, 2 vols. (Philadelphia: Westminster).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Campbell, Constantine R. (2012), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Paul and Union with Christ: An Exegetical and Theological Study")]), _vm._v(" (Grand Rapids: Zondervan).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Campbell, Douglas A. (1994), ‘Romans 1:17: A "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Crux Interpretum")]), _vm._v(" for the "), _c('span', {
    staticClass: "greek_roman"
  }, [_vm._v("ΠΙΣΤΙΣ ΧΡΙΣΤΟΥ")]), _vm._v(" Debate’, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("JBL")]), _vm._v(" 113, pp. 265–285.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Campbell, William S. (1991), ‘Romans III as a Key to the Structure and Thought of the Letter’, in K. P. Donfried (ed.),"), _c('em', {
    staticClass: "italic"
  }, [_vm._v(" The Romans Debate: Revised and Expanded Edition")]), _vm._v(" (Peabody: Hendrickson), pp. 251–264.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Caplan, H., et al. (tr.) (1913–), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Cicero")]), _vm._v(", 29 vols., LCL (Cambridge: Harvard University Press).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Casson, Sarah H. (2019), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Textual Signposts in the Argument of Romans: A Relevance-Theory Approach")]), _vm._v(", ECL (Atlanta: SBL Press).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Chae, Daniel Jong-Sang (1997), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Paul as Apostle to the Gentiles: His Apostolic Self-Awareness and Its Influence on the Soteriological Argument in Romans")]), _vm._v(" (Carlisle: Paternoster).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Childs, Brevard S. (1984), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The New Testament as Canon: An Introduction")]), _vm._v(" (Philadelphia: Fortress).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("—— (2001), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Isaiah")]), _vm._v(", OTL (Philadelphia: Westminster John Knox).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Clarke, Andrew D. (1990), ‘The Good and the Just in Romans 5:7’, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("TynBul ")]), _vm._v("41, pp. 128–142.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Colson, F. H., G. H Whitaker and R. Marcus (tr.) (1929–62), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Philo")]), _vm._v(", 12 vols., LCL (Cambridge: Harvard University Press).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Cosgrove, Charles H. (1987), ‘What If Some Have Not Believed? Occasion and Thrust of Romans 3:1–8’, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("ZNW ")]), _vm._v("78, pp. 90–105.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Crafton, Jeffrey A. (1990), ‘Paul’s Rhetorical Vision and the Purpose of Romans: Toward a New Understanding’, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("NovT")]), _vm._v(" 32, pp. 317–339.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Cranfield, C. E. B. (1994), ‘Romans 6:1–14 Revisited’, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("ExpTim ")]), _vm._v("106, pp. 40–43.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Curtis, Heath R. (2002), ‘A Female Apostle? A Note Re-examining the Work of Burer and Wallace concerning "), _c('span', {
    staticClass: "greek_roman"
  }, [_vm._v("ἐπίσημοι")]), _vm._v(" with "), _c('span', {
    staticClass: "greek_roman"
  }, [_vm._v("ἐν")]), _vm._v(" and the Dative’, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("CJ")]), _vm._v(" 28, pp. 437–440.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Dabourne, Wendy (1999), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Purpose and Cause in Pauline Exegesis: Romans 1.16 – 4.25 and a New Approach to the Letters")]), _vm._v(", SNTSMS 104 (Cambridge: Cambridge University Press).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Dahl, Nils A. (1977), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Studies in Paul ")]), _vm._v("(Minneapolis: Augsburg).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Danby, Herbert (1933), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Mishnah")]), _vm._v(" (Oxford: Oxford University Press).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Das, A. Andrew (2007), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Solving the Romans Debate")]), _vm._v(" (Minneapolis: Fortress).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Dauge, Yves Albert (1981), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Le Barbare: recherches sur la conception romaine de la barbarie et de la civilization")]), _vm._v(", Classical Antiquity 176 (Brussels: Latomus).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Davies, W. D. (1965), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Paul and Rabbinic Judaism: Some Rabbinic Elements in Pauline Theology")]), _vm._v(", rev. edn (New York: Harper).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("—— (1977–8), ‘Paul and the People of Israel’, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("NTS")]), _c('em', {
    staticClass: "italic"
  }), _vm._v("24, pp. 4–39.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Davies, W. D. and Dale C. Allison (1988), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Gospel according to St. Matthew")]), _vm._v(", Vol. 1, ICC (Edinburgh: T&T Clark).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("DeSilva, David A. (2004), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("An Introduction to the New Testament ")]), _vm._v("(Downers Grove: InterVarsity Press; Leicester: Apollos).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Dewey, Arthur J. (1994), ‘"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("EIS THN SPANIAN")]), _vm._v(": The Future and Paul’, in L. Bormann, K. Del Tredici and A. Standhartinger (eds.),"), _c('em', {
    staticClass: "italic"
  }, [_vm._v(" Religious Propaganda and Missionary Competition in the New Testament World: Essays Honoring Dieter Georgi")]), _vm._v(", NovTSup 74 (Leiden: Brill), pp. 321–349.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Dixon, Thomas P. (2020), ‘Judgement for Israel: The Marriage of Wrath and Mercy in Romans 9 – 11’, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("NTS ")]), _vm._v("66, pp. 565–581.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Doeve, J. W. (1953), ‘Some Notes with Reference to "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("ta logia tou theou ")]), _vm._v("in Romans 3.2’, in J. N. Sevenster and W. C. van Unnik (eds.), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Studia Paulina in Honorem Johannis de Zwaan ")]), _vm._v("(Haarlem: Bohn), pp. 111–123.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Donaldson, Terence L. (1997), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Paul and the Gentiles: Remapping the Apostle’s Convictional World ")]), _vm._v("(Minneapolis: Fortress).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Donfried, Karl P. (ed.) (1991a), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Romans Debate: Revised and Expanded Edition")]), _vm._v(" (Peabody: Hendrickson).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("—— (1991b), ‘False Presuppositions in the Study of Romans’, in K. P. Donfried (ed.),"), _c('em', {
    staticClass: "italic"
  }, [_vm._v(" The Romans Debate: Revised and Expanded Edition")]), _vm._v(" (Peabody: Hendrickson), pp. 102–125.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("—— (2007), ‘Paul and the Revisionists: Did Luther Really Get It All Wrong?’, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Dialog ")]), _vm._v("46, pp. 31–40.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Douglass, Frederick (1846), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Narrative of the Life of Frederick Douglass: An American Slave Written by Himself")]), _vm._v(", 2nd edn (Dublin: Webb and Chapman).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Downs, David J. (2008), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Offering of the Gentiles: Collection for Jerusalem in Its Chronological, Cultural, and Cultic Contexts")]), _vm._v(", WUNT 2/248 (Tübingen: Mohr Siebeck).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Dryden, J. de Waal (2015), ‘Revisiting Romans 7: Law, Self and Spirit’, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("JSPL")]), _vm._v(" 5, pp. 129–151.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Duncan, George S. (1934), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Epistle of Paul to the Galatians")]), _vm._v(" (New York: Harper).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Duncan, John (2015), ‘The Hope of Creation: The Significance of "), _c('span', {
    staticClass: "greek_roman"
  }, [_vm._v("ἐφ")]), _vm._v("’ "), _c('span', {
    staticClass: "greek_roman"
  }, [_vm._v("ἑλπίδι")]), _vm._v(" (Rom 8.20c) in Context’, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("NTS")]), _vm._v(" 61, pp. 411–427.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Dunn, James D. G. (1982), ‘Salvation Proclaimed: VI. Romans 6,1–11: Dead and Alive’, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("ExpTim")]), _vm._v(" 93, pp. 259–264.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("—— (2008), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The New Perspective on Paul")]), _vm._v(", rev. edn (Grand Rapids: Eerdmans).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Du Toit, A. B. (1989), ‘Persuasion in Romans 1:1–17’, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("BZ ")]), _vm._v("33, pp. 192–209.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Eastman, Susan (2010), ‘Israel and Divine Mercy in Galatians and Romans’, in F. Wilk and J. R. Wagner (eds.), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Between Gospel and Election: Explorations in the Interpretation of Romans 9 – 11")]), _vm._v(" (Tübingen: Mohr Siebeck), pp. 147–170.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Edwards, James R. (2019), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Between the Swastika and the Sickle: The Life, Disappearance, and Execution of Ernst Lohmeyer")]), _vm._v(" (Grand Rapids: Eerdmans).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Engberg-Pedersen, Troels (2006), ‘Paul’s Stoicizing Politics in Romans 12 – 13: The Role of 13.1–10 in the Argument’, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("JSNT")]), _vm._v(" 29, pp. 163–172.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Epictetus (1926–8), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Discourses as Reported by Arrian; the Manual; and Fragments")]), _vm._v(", tr. W. A. Oldfather, 2 vols., LCL (Cambridge: Harvard University Press).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Epp, Eldon J. (2005), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Junia: The First Woman Apostle")]), _vm._v(" (Minneapolis: Fortress).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Epstein, Isidore (ed.) (1948), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Soncino Talmud")]), _vm._v(", 18 vols. (London: Soncino).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Esler, Philip F. (2003a), ‘Ancient Oleiculture and Ethnic Differentiation: The Meaning of the Olive-Tree Image in Romans 11’, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("JSNT")]), _vm._v(" 26, pp. 103–124.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("—— (2003b), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Conflict and Identity in Romans: The Social Setting of Paul’s Letter")]), _vm._v(" (Minneapolis: Fortress).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Fatehi, Mehrdad (2000), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Spirit’s Relation to the Risen Lord in Paul: An Examination of Its Christological Implications")]), _vm._v(", WUNT 2/128 (Tübingen: Mohr Siebeck).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Fee, Gordon D. (1994), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("God’s Empowering Presence: The Holy Spirit in the Letters of Paul ")]), _vm._v("(Peabody: Hendrickson).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Feldman, Louis H. (1993), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Jew and Gentile in the Ancient World")]), _vm._v(" (Princeton: Princeton University Press).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Feldmeier, Reinhard (2014), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Power, Service, Humility: A New Testament Ethic")]), _vm._v(" (Waco: Baylor University Press).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Ferguson, John (1970), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Religions of the Roman Empire ")]), _vm._v("(Ithaca: Cornell University Press).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Feuillet, Andre (1959), ‘La Citation d’Habacuc 2:4 et les huit premiers chapitres de l’Epître aux Romains’, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("NTS")]), _vm._v(" 6, pp. 52–80.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("—— (1970), ‘Le Règne de la mort et le règne de la vie’, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("RB")]), _vm._v(" 77, pp. 481–521.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Fitzmyer, Joseph A. (1993), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("According to Paul: Studies in the Theology of the Apostle")]), _vm._v(" (New York: Paulist).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Fowler, Paul B. (2016), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Structure of Romans: The Argument of Paul’s Letter")]), _vm._v(" (Minneapolis: Fortress).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("France, R. T. (1999), ‘From Romans to the Real World: Biblical Principles and Cultural Change in Relation to Homosexuality and the Ministry of Women’, in S. K. Soderlund and N. T. Wright (eds.),"), _c('em', {
    staticClass: "italic"
  }, [_vm._v(" Romans and the People of God: Essays in Honor of Gordon D. Fee on the Occasion of His 65th Birthday")]), _vm._v(" (Grand Rapids: Eerdmans), pp. 234–253.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Freedman H. and Maurice Simon (eds.) (1983), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Midrash Rabbah: Genesis")]), _vm._v(", 3rd edn (London/New York: Soncino).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Fryer, Nico S. L. (1987), ‘The Meaning and Translation of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Hilastērion")]), _vm._v(" in Romans 3:25’, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("EvQ")]), _vm._v(" 59, pp. 99–116.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Furnish, Victor Paul (1972), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Love Command in the New Testament")]), _vm._v(" (Nashville: Abingdon).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Gäckle, Volker (2005), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Die Starken und die Schwachen in Korinth und in Rom: Zu Herkunft und Funktion der Antithese in 1Kor 8,1 – 11,1 und in Rom 14,1 – 15,13")]), _vm._v(", WUNT 2/200 (Tübingen: Mohr Siebeck).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Gagnon, Robert A. J. (2001), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Bible and Homosexual Practice: Texts and Hermeneutics")]), _vm._v(" (Nashville: Abingdon).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Gamble, Harry, Jr (1977), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Textual History of the Letter to the Romans: A Study in Textual and Literary Criticism")]), _vm._v(", Studies and Documents 42 (Grand Rapids: Eerdmans).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Garland, David E. (2003), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("1 Corinthians")]), _vm._v(", BECNT (Grand Rapids: Baker).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("—— (2015), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("A Theology of Mark")]), _vm._v(", BTNT (Grand Rapids: Zondervan).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("—— (2021), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("2 Corinthians")]), _vm._v(", rev. edn, CSC (Nashville: Holman Reference).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Gathercole, Simon J. (2002), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Where Is Boasting? Early Jewish Soteriology and Paul’s Response in Romans 1 – 5")]), _vm._v(" (Grand Rapids: Eerdmans).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("—— (2006), ‘The Doctrine of Justification in Paul and Beyond: Some Proposals’, in B. L. McCormack (ed.), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Justification in Perspective: Historical Developments and Contemporary Challenges ")]), _vm._v("(Grand Rapids: Baker), pp. 219–241.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("—— (2018), ‘“Sins” in Paul’, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("NTS ")]), _vm._v("64, pp. 143–161.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Gaventa, Beverly Roberts (2010), ‘On the Calling-Into-Being of Israel: Romans 9:6–29’, in F. Wilk and J. R. Wagner (eds.), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Between Gospel and Election: Explorations in the Interpretation of Romans 9 – 11")]), _vm._v(", WUNT 2/257 (Tübingen: Mohr Siebeck), pp. 255–269.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Gibson, Jeffrey B. (2004), ‘Paul’s “Dying Formula”: Prolegomena to an Understanding of Its Import and Significance’, in S. E. McGinn (ed.), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Celebrating Romans: Template for Pauline Theology; Essays in Honor of Robert Jewett")]), _vm._v(" (Grand Rapids: Eerdmans), pp. 20–41.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Gieniusz, Andrzej (1993), ‘Rom 7,1–6: Lack of Imagination? Function of the Passage in the Argumentation of Rom 6,1 – 7,6’, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Bib")]), _vm._v(" 74, pp. 389–400.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("—— (1999), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Romans 8:18–30: ‘Suffering Does Not Thwart the Future Glory’")]), _vm._v(", USFISFCJ (Atlanta: Scholars Press).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Gignilliat, Mark S. (2006), ‘Working Together with Whom? Text-Critical, Contextual, and Theological Analysis of "), _c('span', {
    staticClass: "greek_roman"
  }, [_vm._v("συνεργεῖ")]), _vm._v(" in Romans 8,28’, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Bib")]), _vm._v(" 87, pp. 511–515.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Glad, Clarence E. (1995), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Paul and Philodemus: Adaptability in Epicurean and Early Christian Psychagogy")]), _vm._v(", NovTSup 81 (Leiden/New York/Cologne: Brill).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Glancy, Jennifer (2011), ‘Slavery and the Rise of Christianity’, in K. Bradley and P. Cartledge (eds.),"), _c('em', {
    staticClass: "italic"
  }, [_vm._v(" The Ancient Mediterranean World")]), _vm._v(", The Cambridge World History of Slavery Vol. 1 (Cambridge: Cambridge University Press), pp. 456–481.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Goodrich, John K. (2011), ‘Erastus of Corinth (Romans 16.23): Responding to Recent Proposals on His Rank, Status, and Faith’, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("NTS")]), _vm._v(" 57, pp. 583–593.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("—— (2012), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Paul as an Administrator of God in 1 Corinthians")]), _vm._v(", SNTSMS 152 (Cambridge: Cambridge University Press).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("—— (2013), ‘From Slaves of Sin to Slaves of God’, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("BBR ")]), _vm._v("23, pp. 509–530.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Gordon, Benjamin D. (2016), ‘On the Sanctity of Mixtures and Branches: Two Halakic Sayings in Romans 11:16–24’, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("JBL")]), _vm._v(" 135, pp. 355–368.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Grindheim, Sigurd (2005), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Crux of Election: Paul’s Critique of the Jewish Confidence in the Election of Israel")]), _vm._v(", WUNT 2/202 (Tübingen: Mohr Siebeck).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Gundry, Robert H. (2010), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Commentary on the New Testament ")]), _vm._v("(Peabody: Hendrickson).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Gupta, Nijay H. (2012), ‘Mirror-Reading Moral Issues in Paul’s Letters’, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("JSNT")]), _vm._v(" 34, pp. 361–381.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Haacker, Klaus (2003), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Theology of Paul’s Letter to the Romans ")]), _vm._v("(Cambridge: Cambridge University Press).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Hall, David R. (1983), ‘Romans 3.1–8 Reconsidered’, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("NTS")]), _vm._v(" 29, pp. 183–197.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Harrington, Hannah K. (2001), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Holiness: Rabbinic Judaism and the Graeco-Roman World")]), _vm._v(" (London/New York: Routledge).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Harris, Murray J. (1986), ‘Appendix: Prepositions and Theology in the Greek New Testament’, in C. Brown (ed.),"), _c('em', {
    staticClass: "italic"
  }, [_vm._v(" The New International Dictionary of New Testament Theology")]), _vm._v(", Vol. 3 (Grand Rapids: Zondervan), pp. 1117–1215.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Harrisville, Roy A., III (1994), ‘"), _c('span', {
    staticClass: "greek_roman"
  }, [_vm._v("Πίστις Χριστοῦ")]), _vm._v(": Witness of the Fathers’, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("NovT ")]), _vm._v("36, pp. 232–241.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Hartwig, Charlotte and Gerd Theissen (2004), ‘Die korinthische Gemeinde als Nebenadressat des Römerbriefs: Eigentextreferenzen des Paulus und kommunikativer Kontext des längsten Paulusbriefes’, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("NovT")]), _vm._v(" 46, pp. 229–252.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Havemann, J. C. T. (1997), ‘Cultivated Olive – Wild Olive: The Olive Tree Metaphor in Romans 11:16–24’, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Neot ")]), _vm._v("31, pp. 87–106.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Hays, Richard B. (1985), ‘“Have We Found Abraham to Be Our Forefather according to the Flesh?” A Reconsideration of Rom 4:1’, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("NovT ")]), _vm._v("27, pp. 76–91.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("—— (1989), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Echoes of Scripture in the Letters of Paul ")]), _vm._v("(New Haven: Yale University"), _c('span', {
    staticClass: "bold"
  }), _vm._v("Press).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("—— (2002), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Faith of Jesus Christ: The Narrative Substructure of Galatians 3:1 – 4:11")]), _vm._v(", rev. edn (Grand Rapids: Eerdmans).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Hengel, Martin (1977), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Crucifixion")]), _vm._v(" (Philadelphia: Fortress).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("—— (1992), ‘Christological Titles in Early Christianity’, in J. H. Charlesworth"), _c('em', {
    staticClass: "italic"
  }), _vm._v("(ed.), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Messiah: Developments in Earliest Judaism and Christianity")]), _vm._v(" (Minneapolis: Fortress), pp. 425–448.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Heschel, Abraham J. (1968), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Who Is Man?")]), _vm._v(" (Stanford: Stanford University Press).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Hill, Wesley (2015), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Paul and the Trinity: Persons, Relations, and the Pauline Letters")]), _vm._v(" (Grand Rapids: Eerdmans).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Hoekema, Anthony A. (1971), ‘The Christian’s Self-Image’,"), _c('em', {
    staticClass: "italic"
  }), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Reformed Journal")]), _vm._v(" 20, pp. 17–20.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Holloway, Paul A. (2003), ‘The Rhetoric of Romans’, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("RevExp")]), _vm._v(" 100, pp. 113–127.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Hooker, Morna D. (2003), ‘The Authority of the Bible: A New Testament Perspective’, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Ex Auditu")]), _vm._v(" 19, pp. 44–64.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Hurtado, Larry W. (1981), ‘The Doxology at the End of Romans’, in E. J. Epp and G. D. Fee (eds.), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("New Testament Textual Criticism: Its Significance for Exegesis")]), _vm._v(" (Oxford: Clarendon), pp. 185–199.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("—— (1999), ‘Jesus’ Divine Sonship in Paul’s Epistle to the Romans’, in S. K. Soderlund and N. T. Wright (eds.),"), _c('em', {
    staticClass: "italic"
  }, [_vm._v(" Romans and the People of God: Essays in Honor of Gordon D. Fee on His 65th Birthday")]), _vm._v(" (Grand Rapids: Eerdmans), pp. 217–233.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("—— (2003), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Lord Jesus Christ: Devotion to Jesus in Earliest Christianity ")]), _vm._v("(Grand Rapids: Eerdmans).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Hvalvik, Reidar (1990), ‘A “Sonderweg” for Israel: A Critical Examination of a Current Interpretation of Romans 11.25–27’, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("JSNT")]), _vm._v(" 38, pp. 87–107.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Irons, Charles Lee (2015), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Righteousness of God: A Lexical Examination of the Covenant-Faithfulness Interpretation")]), _vm._v(", WUNT 2/386 (Tübingen: Mohr Siebeck).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Jervell, Jacob (1991), ‘The Letter to Jerusalem’, in K. P. Donfried (ed.), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Romans Debate: Revised and Expanded Edition")]), _vm._v(" (Peabody: Hendrickson), pp. 53–64.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Jervis, L. Ann (1991), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Purpose of Romans: A Comparative Letter Structure Investigation")]), _vm._v(", JSNTSup 55 (Sheffield: JSOT Press).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Jewett, Robert (1990), ‘Paul, Phoebe, and the Spanish Mission’, in J. Neusner"), _c('em', {
    staticClass: "italic"
  }), _vm._v("(ed.), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Social World of Early Christianity: Festschrift for Howard Clark Kee")]), _vm._v(" (Philadelphia: Fortress), pp. 142–161.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Jipp, Joshua W. (2009), ‘Ancient, Modern, and Future Interpretations of Romans 1:3–4: Reception History and Biblical Interpretation’, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("JTI ")]), _vm._v("3, pp. 241–259.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("——"), _c('em', {
    staticClass: "italic"
  }), _vm._v("(2015), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Christ Is King: Paul’s Royal Christology")]), _vm._v(" (Minneapolis: Fortress).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Jocz, Jakob (1966), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Christians and Jews: Encounter and Mission ")]), _vm._v("(London: SPCK).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Johansen, Bjorn O. (2016), ‘The “I” of Romans 7 and Confessions in the Dead Sea Scrolls’, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("BN")]), _vm._v(" 170, pp. 101–118.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Johnson, E. Elizabeth (2012), ‘God’s Covenant Faithfulness to Israel’, in J. L. Sumney (ed.), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Reading Paul’s Letter to the Romans ")]), _vm._v("(Atlanta: Society of Biblical Literature), pp. 157–167.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Johnson, S. Lewis, Jr (1972), ‘“God Gave Them Up”: A Study in Divine Retribution (Romans 1:24, 26, 28)’, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("BSac ")]), _vm._v("129, pp. 124–133.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Kadushin, Max (1938), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Organic Thinking: A Study in Rabbinic Thought")]), _vm._v(" (New York: Bloch).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Karris, Robert J. (1991), ‘Romans 14:1 – 15:13 and the Occasion of Romans’, in K. P. Donfried (ed.), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Romans Debate: Revised and Expanded Edition")]), _vm._v(" (Peabody: Hendrickson), pp. 65–84.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Käsemann, Ernst (1965), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Essays on New Testament Themes")]), _vm._v(", SBT 41 (London: SCM).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("—— (1971), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Perspectives on Paul ")]), _vm._v("(Philadelphia: Fortress).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Kaye, Bruce Norman (1979), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Thought Structure of Romans with Special Reference to Chapter 6")]), _vm._v(" (Austin: Schola Press).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Kaylor, R. David (1988), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Paul’s Covenant Community: Jew and Gentile in Romans")]), _vm._v(" (Atlanta: John Knox).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Keck, Leander E. (1979), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Paul and His Letters")]), _vm._v(", Proclamation Commentaries (Philadelphia: Fortress).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("—— (2015), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Why Christ Matters: Towards a New Testament Christology")]), _vm._v(" (Waco: Baylor University Press).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Keener, Craig S. (2014), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Acts: An Exegetical Commentary, Volume 3: 15:1 – 23:35")]), _vm._v(" (Grand Rapids: Baker Academic).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("——"), _c('em', {
    staticClass: "italic"
  }), _vm._v("(2016), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Mind of the Spirit: Paul’s Approach to Transformed Thinking")]), _vm._v(" (Grand Rapids: Baker).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Kertelge, Karl (1991), ‘The Sin of Adam in the Light of Christ’s Redemptive Act according to Romans 5:12–21’, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Communio ")]), _vm._v("18, pp. 502–513.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Kettunen, Markku (1979), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Abfassungszweck des Römerbriefes")]), _vm._v(", AASF: Dissertationes humanarum litterarum 18 (Helsinki: Suomalainen Tiedeakatemia).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Kim, Seyoon (1997), ‘The “Mystery” of Rom 11.25–6 Once More’, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("NTS ")]), _vm._v("43, pp. 412–429.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Kirk, J. R. Daniel (2007), ‘Reconsidering "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Dikaiōma ")]), _vm._v("in Romans 5:16’, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("JBL")]), _vm._v(" 126, pp. 787–792.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Kister, Menachem (2007), ‘Romans 5:12–21 against the Background of Torah-Theology and Hebrew Usage’, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("HTR")]), _vm._v(" 100, pp. 391–424.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Knox, John (1961), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Life in Christ Jesus: Reflections on Romans 5 – 8")]), _vm._v(" (New York: Seabury).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("—— (1962), ‘Galatians’, in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Interpreter’s Dictionary of the Bible")]), _vm._v(" (Nashville/New York: Abingdon), pp. 338–343.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Krauter, Stefan (2009), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Studien zu Röm 13,1–7: Paulus und der politische Diskurs der neronischen Zeit")]), _vm._v(", WUNT 243 (Tübingen: Mohr Siebeck).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Kürzinger, Josef (1958), ‘"), _c('span', {
    staticClass: "greek_roman"
  }, [_vm._v("Συμμόρφους τῆς εἰκόνος τοῦ υἱοῦ αὐτοῦ")]), _vm._v(" (Rom. 8, 29)’, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("BZ")]), _vm._v(" 2, pp. 294–299.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Lake, Kirsopp (tr.) (1920), ‘The Martyrdom of Polycarp’, in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Apostolic Fathers II")]), _vm._v(", LCL (Cambridge: Harvard University Press), pp. 309–343.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Lambrecht, Jan (2000), ‘The Implied Exhortation in Romans 8,5–8’, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Gregorianum")]), _vm._v(" 81, pp. 441–451.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Lambrecht, Jan and Richard W. Thompson (1989), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Justification by Faith: The Implications of Romans 3:27–31")]), _vm._v(" (Wilmington: Michael Glazier).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Lampe, Peter (2003), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("From Paul to Valentinus: Christians at Rome in the First Two Centuries")]), _vm._v(" (Minneapolis: Fortress).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Lichtenberger, Hermann (2004), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Das Ich Adams und das Ich der Menschheit: Studien zum Menschenbild in Römer 7")]), _vm._v(", WUNT 163 (Tübingen: Mohr Siebeck).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Lin, Yii-Jan (2020), ‘Junia: An Apostle before Paul’, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("JBL")]), _vm._v(" 139, pp. 191–209.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Longenecker, Bruce W. (2010), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Remember the Poor: Paul, Poverty, and the Greco-Roman World ")]), _vm._v("(Grand Rapids: Eerdmans).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Longenecker, Bruce W. and Todd D. Still (2014), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Thinking through Paul: A Survey of His Life, Letters, and Theology")]), _vm._v(" (Grand Rapids: Zondervan).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Lowe, Chuck (1999), ‘“There Is No Condemnation” (Romans 8:1): But Why Not?’, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("JETS")]), _c('em', {
    staticClass: "italic"
  }), _vm._v("42, pp. 231–250.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Luther, Martin (1960a), ‘Preface to the Complete Edition of Luther’s Latin Writings: Wittenberg, 1545’, in L. W. Spitz (ed.) and H. T. Lehman (gen. ed.), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Luther’s Works")]), _vm._v(", Vol. 34: "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Career of the Reformer IV ")]), _vm._v("(Philadelphia: Muhlenberg), pp. 327–338.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("—— (1960b), ‘Prefaces to the New Testament 1546 (1522)’, in E. T. Bachmann (ed.) and H. T. Lehman (gen. ed.), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Luther’s Works")]), _vm._v(", Vol. 35: "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Word and Sacrament I ")]), _vm._v("(Philadelphia: Muhlenberg), pp. 357–411.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("—— (1961), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Luther: Lectures on Romans, Library of Christian Classics, Vol. 15, ed. W. Pauck")]), _vm._v(" (Philadelphia: Westminster).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Luz, Ulrich (1969), ‘Zum Aufbau von Rom. 1 – 8’, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("TZ ")]), _vm._v("25, pp. 161–181.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Lyonnet, Stanislas (1965), ‘Le Nouveau Testament à la lumière de l’Ancien: à propos de Rom 8, 2–4’, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("NRTh")]), _vm._v(" 87, pp. 561–587.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("McFadden, Kevin W. (2013), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Judgment according to Works in Romans: The Meaning and Function of Divine Judgment in Paul’s Most Important Letter ")]), _vm._v("(Minneapolis: Fortress).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Manson, T. W. (1945), ‘"), _c('span', {
    staticClass: "greek_roman"
  }, [_vm._v("ΙΛΑΣΤΗΡΙΟΝ")]), _vm._v("’, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("JTS")]), _vm._v(" 46, pp. 1–10.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Marcus, Joel (1988), ‘“Let God Arise and End the Reign of Sin!” A Contribution to the Study of Pauline Parenesis’, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Bib")]), _vm._v(" 69, pp. 386–395.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Marshall, Christopher D. (1989), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Faith as a Theme in Mark’s Narrative")]), _vm._v(", SNTSMS 64 (Cambridge: Cambridge University Press).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Martin, James P. (1971), ‘Kerygma of Romans’, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Interpretation")]), _vm._v(" 25, pp. 303–328.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Martin, Ralph P. (1999), ‘Reconciliation: Romans 5:1–11’, in S. K. Soderlund and N. T. Wright (eds.), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Romans and the People of God: Essays in Honor of Gordon D. Fee on the Occasion of His 65th Birthday")]), _vm._v(" (Grand Rapids: Eerdmans), pp. 36–48.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Martínez, Florentino García (1994), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Dead Sea Scrolls Translated: The Qumran Texts in English")]), _vm._v(", tr. W. G. E. Watson (Leiden/New York/Cologne: Brill).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Martyn, J. Louis (1997a), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Galatians")]), _vm._v(", AB (New York: Doubleday).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("—— (1997b), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Theological Issues in the Letters of Paul")]), _vm._v(" (Edinburgh: T&T Clark).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Mason, Hugh J. (1974), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Greek Terms for Roman Institutions: A Lexicon and Analysis")]), _vm._v(", American Studies in Papyrology"), _c('em', {
    staticClass: "italic"
  }), _vm._v("13 (Toronto: Hakkert).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Maston, Jason (2010), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Divine and Human Agency in Second Temple Judaism and Paul: A Comparative Study")]), _vm._v(" (Tübingen: Mohr Siebeck)"), _c('em', {
    staticClass: "italic"
  }, [_vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Meeks, Wayne A. (1987), ‘Judgment and the Brother: Romans 14:1 – 15:13’, in G. F. Hawthorne and O. Betz (eds.), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Tradition and Interpretation in the New Testament: Essays in Honor of E. Earle Ellis for His 60th Birthday")]), _vm._v(" (Grand Rapids: Eerdmans), pp. 290–300.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Melanchthon, Philip (1944), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Loci Communes of Philip Melanchthon")]), _vm._v(", tr. C. L. Hill (Boston: Meador).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Metzger, Bruce Manning (1965), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The New Testament: Its Background, Growth, and Content")]), _vm._v(" (Nashville: Abingdon).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Meyer, Paul W. (1980), ‘Romans 10:4 and the End of the Law’, in J. L. Crenshaw and S. Sandmel"), _c('em', {
    staticClass: "italic"
  }), _vm._v("(eds.), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Divine Helmsman: Studies on God’s Control of Human Events ")]), _vm._v("(New York: Ktav, 1980), pp. 59–78.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Minear, Paul S. (1971), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Obedience of Faith: The Purposes of Paul in the Epistle to the Romans")]), _vm._v(", SBT (London: SCM).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Mininger, Marcus A. (2017), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Uncovering the Theme of Revelation in Romans 1:16 – 3:26")]), _vm._v(", WUNT 2/445 (Tübingen: Mohr Siebeck).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Mitchell, Margaret (2002), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Heavenly Trumpet: John Chrysostom and the Art of Pauline Interpretation")]), _vm._v(" (Louisville/London: Westminster John Knox).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Moltmann, Jürgen (2004), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Coming of God: Christian Eschatology")]), _vm._v(" (Minneapolis: Fortress).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Moo, Jonathan (2008), ‘Romans 8.19–22 and Isaiah’s Cosmic Covenant’, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("NTS ")]), _vm._v("54, pp. 74–89.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Morrison, Clinton D. (1960), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Powers That Be")]), _vm._v(", SBT 29 (Naperville: Allenson).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Motyer, Steve (1989), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Israel in the Plan of God ")]), _vm._v("(Leicester: Inter-Varsity Press).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Moule, C. F. D. (1963), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Meaning of Hope: A Biblical Exposition with Concordance ")]), _vm._v("(Philadelphia: Fortress).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("—— (1974), ‘“Justification” in Its Relation to the Condition "), _c('span', {
    staticClass: "greek_roman"
  }, [_vm._v("κατά πνεύμα")]), _vm._v(" (Rom. 8.1–11)’, in L. De Lorenzi (ed.),"), _c('em', {
    staticClass: "italic"
  }, [_vm._v(" Battesimo e Giustizia in Rom 6 e 8")]), _vm._v(" (Roma: Abbazia S. Paolo fuori le mura), pp. 176–201.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Mukuka, Tarcisius (2012), ‘Reading/Hearing Romans 13:1–7 under an African Tree: Towards a Lectio Postcolonica Contexta Africana’, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Neot")]), _vm._v(" 46, pp. 105–138.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Munck, Johannes (1967), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Christ and Israel: An Interpretation of Romans 9 – 11")]), _vm._v(" (Philadelphia: Fortress).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Murphy-O’Connor, Jerome (1996), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Paul: A Critical Life ")]), _vm._v("(Oxford: Oxford University Press).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Nanos, Mark D. (1996), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Mystery of Romans: The Jewish Context of Paul’s Letter")]), _vm._v(" (Minneapolis: Fortress, 1996).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Naselli, Andrew David (2012), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("From Typology to Doxology: Paul’s Use of Isaiah and Job in Romans 11:34–35")]), _vm._v(" (Eugene: Pickwick).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Nolland, John (2000), ‘Romans 1:26–27 and the Homosexuality Debate’, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("HBT")]), _vm._v(" 22, pp. 32–57.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Ogereau, Julien M. (2012), ‘The Jerusalem Collection as "), _c('span', {
    staticClass: "greek_roman"
  }, [_vm._v("Κοινωνία")]), _vm._v(": Paul’s Global Politics of Socio-Economic Equality and Solidarity’, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("NTS ")]), _vm._v("58, pp. 360–378.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Olin, John C. (ed.) (1966), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("A Reformation Debate: Sadoleto’s Letter to the Genevans and Calvin’s Reply ")]), _vm._v("(Grand Rapids: Baker).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Olson, Robert C. (2016), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Gospel as the Revelation of God’s Righteousness: Paul’s Use of Isaiah in Romans 1:1 – 3:26")]), _vm._v(", WUNT 2/428 (Tübingen: Mohr Siebeck).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Oropeza, B. J. (2016), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Exploring Second Corinthians: Death and Life, Hardship and Rivalry")]), _vm._v(" (Atlanta: SBL).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Ovid (1984), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Metamorphoses, Books 1–8")]), _vm._v(", tr. F. J. Miller and G. O. Goold, LCL (Cambridge: Harvard University Press).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Oyserman, Daphna, Kristen Elmore and George Smith (2012), ‘Self, Self-Concept, and Identity’, in M. R. Leary and J. Price Tangney (eds.),"), _c('em', {
    staticClass: "italic"
  }, [_vm._v(" Handbook of Self and Identity")]), _vm._v(", rev. edn (New York/London: Guilford Press), pp. 69–104.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Pascal, Blaise (2003), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Pensées")]), _vm._v(", tr. W. F. Trotter (Mineola: Dover; orig. New York: Dutton, 1958).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Paul, Shalom M. (2012), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Isaiah 40 – 66: Translation and Commentary")]), _vm._v(", ECC (Grand Rapids: Eerdmans).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Pedersen, Johannes (1926), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Israel: Its Life and Culture, I–II")]), _vm._v(" (London: Oxford University Press).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Peek, Werner (ed.) (1957), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Griechische Vers-Inschriften, Band 1: Grab-Epigramme")]), _vm._v(" (Berlin: Akadamie-Verlag).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Peppard, Michael (2011), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Son of God in the Roman World: Divine Sonship in Its Social and Political Context")]), _vm._v(" (New York: Oxford University Press).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Peterman, G. W. (1994), ‘Make a Contribution or Establish Fellowship?’, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("NTS")]), _vm._v(" 40, pp. 457–463.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Peterson, David G. (1995), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Possessed by God: A New Testament Theology of Sanctification and Holiness")]), _vm._v(", NSBT (Leicester: Apollos).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Pinter, Dean (2015), ‘Josephus and Romans 13:1–14: Providence and Imperial Power’, in B. C. Blackwell, J. K. Goodrich and J. Maston (eds.), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Reading Romans in Context: Paul and Second Temple Judaism")]), _vm._v(" (Grand Rapids: Zondervan), pp. 143–150.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Piper, John (1994), ‘“Grace to You” and “Grace with You”’, Desiring God, 28 August, <"), _c('a', {
    staticClass: "www",
    attrs: {
      "href": "https://www.desiringgod.org/messages/grace-to-you-and-grace-with-you",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "Hyperlink"
  }, [_vm._v("https://www.desiringgod.org/messages/grace-to-you-and-grace-with-you")])]), _vm._v(">.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Plautus (2011), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Merchant, The Braggart Soldier, The Ghost, The Persian")]), _vm._v(", tr. W. de Mello, LCL (Cambridge: Harvard University Press).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Poirier, John C. (1996), ‘Romans 5:13–14 and the Universality of Law’, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("NovT ")]), _vm._v("38, pp. 344–358.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Popkes, Wiard (1982), ‘Zum Aufbau und Charakter von Römer 1.18–32’, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("NTS")]), _vm._v(" 28, pp. 490–501.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Powers, Daniel G. (2001), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Salvation through Participation: An Examination of the Notion of the Believers’ Corporate Unity with Christ in Early Christian Soteriology")]), _vm._v(", CBET 29 (Leuven: Peeters).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Poythress, Vern S. (1975–76), ‘Is Romans 1:3–4 a Pauline Confession after All?’, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("ExpTim ")]), _vm._v("87, pp. 180–183.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Price, James L. (1980), ‘Romans 6:1–14’, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Int ")]), _vm._v("34, pp. 65–69.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Prior, Michael (1989), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Paul the Letter-Writer and the Second Letter to Timothy")]), _vm._v(", JSNTSup 23 (Sheffield: JSOT Press).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Ptolemy (1980), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Tetrabiblos")]), _vm._v(", tr. F. E. Robbins, LCL (Cambridge: Harvard University Press).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Quarles, Charles L. (2003), ‘From Faith to Faith: A Fresh Examination of the Prepositional in Romans 1.17’, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("NovT")]), _vm._v(" 45, pp. 2–21.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Rabens, Volker (2013), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Holy Spirit and Ethics in Paul: Transforming and Empowering for Religious-Ethical Life")]), _vm._v(", rev. edn (Minneapolis: Fortress).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Räisänen, Heikki (1988), ‘Paul, God, and Israel: Romans 9 – 11 in Recent Research’, in J. Neusner (ed.),"), _c('em', {
    staticClass: "italic"
  }, [_vm._v(" The Social World of Formative Christianity and Judaism: Essays in Tribute to Howard Clark Kee")]), _vm._v(" (Philadelphia: Fortress), pp. 178–206.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Rapinchuk, Mark (1999), ‘Universal Sin and Salvation in Romans 5:12–21’, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("JETS ")]), _vm._v("42, pp. 427–441.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Reichert, Angelika (2001), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Der Römerbrief als Gratwanderung: Eine Untersuchung zur Abfassungsproblematik")]), _vm._v(", FRLANT 194 (Göttingen: Vandenhoeck & Ruprecht).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Richards, E. Randolph (2019), ‘When Is a Letter Not a Letter? Paul, Cicero, and Seneca as Letter Writers’, in J. R. Dodson and D. E. Briones (eds.),"), _c('em', {
    staticClass: "italic"
  }, [_vm._v(" Paul and the Giants of Philosophy: Reading the Apostle in Greco-Roman Context")]), _vm._v(" (Downers Grove: IVP Academic), pp. 86–94.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Rock, Ian E. (2012), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Paul’s Letter to the Romans and Roman Imperialism: An Ideological Analysis of the Exordium (Romans 1:1–17) ")]), _vm._v("(Eugene: Pickwick).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Romanello, Stefano (2003), ‘Rom 7,7–25 and the Impotence of the Law: A Fresh Look at a Much-Debated Topic Using Literary-Rhetorical Analysis’, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Bib")]), _vm._v(" 84, pp. 510–530.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Sanders, E. P. (1983), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Paul, the Law, and the Jewish People")]), _vm._v(" (Philadelphia: Fortress).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("—— (2016), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Paul: The Apostle’s Life, Letters, and Thought")]), _vm._v(" (Minneapolis: Fortress).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Schellenberg, Ryan S. (2013), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Rethinking Paul’s Rhetorical Education: Comparative Rhetoric and 2 Corinthians 10 – 13")]), _vm._v(", ECL 10 (Atlanta: Society of Biblical Literature).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Schnabel, Eckhard J. (2004), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Paul and the Early Church")]), _vm._v(", Early Christian Mission Vol. 2 (Downers Grove: InterVarsity Press).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("—— (2008), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Paul the Missionary: Realities, Strategies and Methods")]), _vm._v(" (Downers Grove: IVP Academic).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("—— (2018), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Jesus, Paul, and the Early Church: Missionary Realities in Historical Contexts; Collected Essays")]), _vm._v(", WUNT 406 (Tübingen: Mohr Siebeck).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Schnelle, Udo (2005), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Apostle Paul: His Life and Theology")]), _vm._v(" (Grand Rapids: Baker).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Schreiner, Thomas R. (1993), ‘Did Paul Believe in Justification by Works? Another Look at Romans 2’, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("BBR")]), _vm._v(" 3, pp. 131–158.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("—— (2006), ‘Corporate and Individual Election in Romans 9: A Response to Brian Abasciano’, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("JETS ")]), _vm._v("49, pp. 373–386.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Schweizer, Eduard (1981), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Holy Spirit ")]), _vm._v("(Philadelphia: Fortress).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Scott, James M. (1992), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Adoption as Sons of God: An Exegetical Investigation into the Background of ΥΙΟΘΕΣΙΑ in the Pauline Corpus")]), _vm._v(", WUNT 2/48 (Tübingen: Mohr Siebeck).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Segal, Alan F. (1990), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Paul the Convert: The Apostolate and Apostasy of Saul the Pharisee ")]), _vm._v("(New Haven: Yale University Press).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Seifrid, Mark A. (1992a), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Justification by Faith: The Origin and Development of a Central Pauline Theme")]), _vm._v(", NovTSup 68 (Leiden: Brill).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("—— (1992b), ‘The Subject of Rom 7:14–25’, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("NovT")]), _vm._v(" 34, pp. 313–333.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("—— (2007), ‘Romans’, in G. K. Beale and D. A. Carson (eds.),"), _c('em', {
    staticClass: "italic"
  }, [_vm._v(" Commentary on the New Testament Use of the Old Testament")]), _vm._v(" (Grand Rapids: Baker), pp. 607–694.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("—— (2010), ‘The New Perspective from Paul’, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("SBJT ")]), _vm._v("14, pp. 20–35.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Seneca the Younger (1920–34), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Ad Lucilium, Epistulae morales")]), _vm._v(", tr. Richard M. Gummere, 3 vols., LCL (Cambridge: Harvard University Press).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Shaw, David A. (2013), ‘Apocalyptic and Covenant: Perspectives on Paul or Antinomies at War?’, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("JSNT")]), _vm._v(" 36, pp. 155–171.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Siikavirta, Samuli (2015), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Baptism and Cognition in Romans 6 – 8: Paul’s Ethics beyond ‘Indicative’ and ‘Imperative’")]), _vm._v(", WUNT 2/407 (Tübingen: Mohr Siebeck).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Smiles, Vincent M. (2002), ‘The Concept of “Zeal” in Second-Temple Judaism and Paul’s Critique of It in Romans 10:2’, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("CBQ ")]), _vm._v("64, pp. 282–299.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Snodgrass, Klyne R. (1986), ‘Justification by Grace – to the Doers: An Analysis of the Place of Romans 2 in the Theology of Paul’, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("NTS")]), _vm._v(" 32, pp. 72–93.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("—— (1988), ‘Spheres of Influence: A Possible Solution to the Problem of Paul and the Law’, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("JSNT")]), _vm._v(" 32, pp. 93–113.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Stagg, Frank (1962), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("New Testament Theology")]), _vm._v(" (Nashville: Broadman).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("—— (1976), ‘The Plight of Jew and Gentile in Sin: Romans 1:18 – 3:20’, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("RevExp")]), _vm._v(" 73, pp. 401–413.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("—— (1980), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Galatians, Romans")]), _vm._v(", Knox Preaching Guides (Atlanta: John Knox).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Starling, David (2017), ‘“For Your Sake We Are Being Killed All Day Long”: Romans 8:36 and the Hermeneutics of Unexplained Suffering’, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Themelios ")]), _vm._v("42, pp. 112–121.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Stowers, Stanley Kent (1981), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Diatribe and Paul’s Letter to the Romans")]), _vm._v(", SBLDS 57 (Chico: Scholars Press).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("—— (1984), ‘Paul’s Dialogue with a Fellow Jew in Romans 3:1–9’, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("CBQ")]), _c('em', {
    staticClass: "italic"
  }), _vm._v("46, pp. 707–722.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("—— (1990), ‘Paul on the Use and Abuse of Reason’, in D. L. Balch et al., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Greeks, Romans, and Christians")]), _vm._v(" (Philadelphia: Fortress),"), _c('em', {
    staticClass: "italic"
  }), _vm._v("pp. 253–286.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Stuhlmacher, Peter (1986), ‘Recent Exegesis on Romans 3:24–26’, in P. Stuhlmacher, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Reconciliation, Law, and Righteousness: Essays in Biblical Theology ")]), _vm._v("(Philadelphia: Fortress), pp. 94–109.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("—— (1991), ‘The Purpose of Romans’, in K. P. Donfried (ed.),"), _c('em', {
    staticClass: "italic"
  }, [_vm._v(" The Romans Debate: Revised and Expanded Edition")]), _vm._v(" (Peabody: Hendrickson), pp. 231–242.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("—— (2001), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("A Challenge to the New Perspective: Revisiting Paul’s Doctrine of Justification with an Essay by Donald A. Hagner")]), _vm._v(" (Downers Grove: InterVarsity Press).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Suggs, M. Jack (1967), ‘“The Word Is Near You”: Romans 10:6–10 within the Purpose of the Letter’, in W. R. Farmer, C. F. D. Moule and R. R. Niebuhr (eds.), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Christian History and Interpretation: Studies Presented to John Knox")]), _vm._v(" (Cambridge: Cambridge University Press), pp. 289–312.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Tacitus, Cornelius (1914), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Agricola, Germania, Dialogus")]), _vm._v(", tr. M. Hutton and W. Peterson, revised by R. M. Ogilvie, E. H. Warmington and M. Winterbottom, LCL (Cambridge: Harvard University Press).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Taylor, John W. (2004), ‘From Faith to Faith: Romans 1.17 in the Light of Greek Idiom’, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("NTS ")]), _vm._v("50, pp. 37–48.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Taylor, N. H. (2008), ‘Dying with Christ in Baptism: Issues in the Translation and Interpretation of Romans 6.3–14’, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("BT ")]), _vm._v("59, pp. 38–49.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Thackeray, H. St J. et al. (tr.) (1926–65), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Josephus")]), _vm._v(", 10 vols., LCL (Cambridge: Harvard University Press).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Thiselton, Anthony C. (2012), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Holy Spirit: In Biblical Teaching, through the Centuries and Today ")]), _vm._v("(Grand Rapids: Eerdmans).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Thorsteinsson, Runar M. (2015), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Paul’s Interlocutor in Romans 2: Function and Identity in the Context of Ancient Epistolography ")]), _vm._v("(Eugene: Wipf and Stock).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Timmins, Will N. (2017), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Romans 7 and Christian Identity: A Study of the ‘I’ in Its Literary Context")]), _vm._v(", SNTSMS 170 (Cambridge: Cambridge University Press).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Tomlinson, Fred Alan (1997), ‘Sacral Manumission Formulae and Romans 6’ (PhD thesis, Southern Baptist Theological Seminary).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Tomson, Peter J. (2003), ‘What Did Paul Mean by “Those Who Know the Law”? (Rom 7.1)’, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("NTS")]), _vm._v(" 49, pp. 573–581.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Turner, Max (1994), ‘The Spirit of Christ and “Divine” Christology’, in J. B. Green and M. Turner (eds.), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Jesus of Nazareth: Lord and Christ ")]), _vm._v("(Grand Rapids: Eerdmans), pp. 413–436.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Van der Horst, Peter W. (2000), ‘“Only Then Will All Israel Be Saved”: A Short Note on the Meaning of "), _c('span', {
    staticClass: "greek_roman"
  }, [_vm._v("καὶ οὕτως")]), _vm._v(" in Romans 11:26’, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("JBL ")]), _vm._v("119, pp. 521–539.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Van de Sandt, H. W. M. (1976), ‘Research into Rom. 8,4a: The Legal Claim of the Law’, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Bijdragen: Tijdschrift voor filosofie en theologie")]), _vm._v(" 37, pp. 252–269.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Verbrugge, Verlyn D. (2011), ‘The Grammatical Internal Evidence for "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("EXOMEN")]), _vm._v(" in Romans 5:1’, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("JETS ")]), _vm._v("54, pp. 559–572.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Viard, Jean-Sébastian (2005), ‘Loi, chair et libération: une solution structurelle au problème de Romains 7,1–6’, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Theoforum")]), _vm._v(" 36, pp. 155–173.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Wagner, J. Ross (2002), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Heralds of the Good News: Isaiah and Paul ‘In Concert’ in the Letter to the Romans")]), _vm._v(", NovTSup 101 (Leiden: Brill).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("—— (2010), ‘“Not from the Jews Only, but Also from the Gentiles”: Mercy to the Nations in Romans 9 – 11’, in F. Wilk and J. R. Wagner (eds.), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Between Gospel and Election: Explorations in the Interpretation of Romans 9 – 11")]), _vm._v(", WUNT 257 (Tübingen: Mohr Siebeck), pp. 417–431.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Watson, Francis (2018), ‘Questiones Disputae: Roman Faith and Christian Faith’, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("NTS")]), _vm._v(" 64, pp. 243–247.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Watts, Rikki E. (1999), ‘“For I Am Not Ashamed of the Gospel”: Romans 1:16–17 and Habakkuk 2:4’, in S. K. Soderlund and N. T. Wright (eds.), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Romans and the People of God: Essays in Honor of Gordon D. Fee on the Occasion of His 65th Birthday")]), _vm._v(" (Grand Rapids: Eerdmans), pp. 3–25.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Wedderburn, A. J. M. (1988), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Reasons for Romans: Studies of the New Testament and Its World")]), _vm._v(" (Edinburgh: T&T Clark).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Weima, Jeffrey A. D. (1994), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Neglected Endings: The Significance of the Pauline Letter Closings")]), _vm._v(", JSNTSup 101 (Sheffield: Sheffield Academic Press, 1994).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("White, Joel R. (2014), ‘“Peace and Security” (1 Thess 5.3): Roman Ideology and Greek Aspiration’, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("NTS")]), _vm._v(" 60, pp. 499–510.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Whiteley, D. E. H. (1974), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Theology of St. Paul")]), _vm._v(", rev. edn (Oxford: Basil Blackwell).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Whittle, Sarah (2015), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Covenant Renewal and the Consecration of the Gentiles in Romans")]), _vm._v(", SNTSMS 161 (Cambridge: Cambridge University Press).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Wiefel, Wolfgang (1991), ‘The Jewish Community in Ancient Rome and the Origins of Roman Christianity’, in K. P. Donfried (ed.), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Romans Debate:")]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Revised and Expanded Edition ")]), _vm._v("(Peabody: Hendrickson), pp. 85–101.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Williams, Sam K. (1980), ‘The “Righteousness of God” in Romans’, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("JBL")]), _vm._v(" 99, pp. 241–290.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Windsor, Lionel J. (2014), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Paul and the Vocation of Israel")]), _vm._v(", BZNW 205 (Berlin: De Gruyter).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Wink, Walter (1992), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Engaging the Powers: Discernment and Resistance in a World of Domination ")]), _vm._v("(Minneapolis: Fortress).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Wischmeyer, Oda (2006), ‘Römer 2.1–24 als Teil der Gerichtsrede des Paulus gegen die Menschheit’, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("NTS")]), _vm._v(" 52, pp. 356–376.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Wisse, Frederik (1972), ‘The Righteous Man and the Good Man in Romans V.7’, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("NTS ")]), _vm._v("19, pp. 91–93.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Wolter, Michael (1978), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Rechtfertigung und zukünftiges Heil: Untersuchungen zu Römer 5,1–11")]), _vm._v(", BZNW 43 (Berlin/New York: de Gruyter).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("—— (2015), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Paul: An Outline of His Theology")]), _vm._v(" (Waco: Baylor University Press).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("—— (2017), ‘“It Is Not as Though the Word of God Has Failed”: God’s Faithfulness and God’s Free Sovereignty in Romans 9:6–29’, in T. D. Still (ed.),"), _c('em', {
    staticClass: "italic"
  }, [_vm._v(" God and Israel: Providence and Purpose in Romans 9 – 11")]), _vm._v(" (Waco: Baylor University Press), pp. 27–47.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Worthington, Jonathan (2016), ‘"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Creatio ex Nihilo ")]), _vm._v("and Romans 4.17 in Context’, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("NTS")]), _vm._v(" 62, pp. 49–59.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Wright, N. T. (1991), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Climax of the Covenant")]), _vm._v(" (Minneapolis: Fortress).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("—— (2009), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Justification: God’s Plan and Paul’s Vision")]), _vm._v(" (Downers Grove: IVP Academic).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("—— (2012), ‘Romans 2:17 – 3:9: A Hidden Clue to the Meaning of Romans?’, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("JSPL")]), _vm._v(" 2, pp. 1–25.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("—— (2013), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Paul and the Faithfulness of God, Book II: Parts III and IV ")]), _vm._v("(Minneapolis: Fortress).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Wu, Siu Fung (2015), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Suffering in Romans")]), _vm._v(" (Eugene: Pickwick).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Wuellner, William (1991), ‘Paul’s Rhetoric of Argumentation in Romans: An Alternative to the Donfried–Karris Debate over Romans’, in K. P. Donfried (ed.), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Romans Debate:")]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Revised and Expanded Edition")]), _vm._v(" (Peabody: Hendrickson), pp. 128–146.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Yates, John W. (2008), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Spirit and Creation in Paul")]), _vm._v(", WUNT 2/251 (Tübingen: Mohr Siebeck).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Yinger, Kent L. (1999), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Paul, Judaism, and Judgment according to Deeds")]), _vm._v(", SNTSMS 105 (Cambridge: Cambridge University Press).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Zeller, Dieter (1973), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Juden und Heiden in der Mission des Paulus: Studien zum Römerbrief")]), _vm._v(", Forschung zur Bibel 1 (Stuttgart: Katholisches Bibelwerk).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Ziesler, John A. (1972), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Meaning of Righteousness in Paul")]), _vm._v(", SNTSMS 20 (Cambridge: Cambridge University Press).")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30080167","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/TNTC_Romans6a.vue
// module id = 75
// module chunks = 0